export const advisorFieldsMap = {
  organizationName: {
    label: 'Organization Legal Name',
    type: 'string',
    shouldSendEmailConfirmation: false,
  },
  organizationDisplayName: {
    label: 'Organization Whitelabel Name',
    type: 'string',
    shouldSendEmailConfirmation: false,
  },
  advisorEmail: {
    label: 'Advisor Email',
    type: 'string',
    shouldSendEmailConfirmation: false,
  },
  isAccountVerified: {
    label: 'Account Verification Status',
    type: 'boolean',
    shouldSendEmailConfirmation: true,
  },
  featureFlags: {
    label: 'Feature Flags',
    type: 'json',
    shouldSendEmailConfirmation: false,
  },
} as const;

export const advisorFields = Object.entries(advisorFieldsMap).map(
  ([key, { label, type, shouldSendEmailConfirmation }]) =>
    ({
      value: key,
      label,
      type,
      shouldSendEmailConfirmation,
    }) as const,
);
